import {NativeDateAdapter} from "@angular/material/core";
import * as dayjs from "dayjs";
import {Injectable} from "@angular/core";

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  format(date: Date, format: string): string {
    return dayjs(date).format(format);
  }
}
